var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`bi bi-question-circle-fill text-${_vm.bsColour} ms-1`,attrs:{"data-bs-toggle":"tooltip","data-bs-placement":_vm.placement,"data-bs-html":_vm.html,"title":_vm.tooltip}})
}
var staticRenderFns = []

export { render, staticRenderFns }